import { render } from "./UpsellingPicker.vue?vue&type=template&id=4f93df1a&scoped=true"
import script from "./UpsellingPicker.vue?vue&type=script&lang=js"
export * from "./UpsellingPicker.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4f93df1a"

export default script